import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FieldValues } from "react-hook-form";
import { Loader } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { magpCMSApi, post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { useDocumentDetails } from "../../../ApprovalManagement/Drilldown.Hooks";
import { useRequisition } from "../Manual.hook";
import { fields } from "../manualConstants";
import { RequisitionProcessFlowChart } from "./RequisitionProcessFlowChart";

export const Requisition: React.FC = (): JSX.Element => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const [tabsData, setTabsData] = useState<any[]>([]);
  const [subTabsData, setSubTabsData] = useState<any[]>([]);

  const [listId, setListId] = useState("");
  const [toggleId, setToggleId] = useState("");
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  const {
    data: requisitionData,
    isLoading: isLoadingRequisition,
    refetch: refetchRequisition,
  } = useRequisition(listId || "26", toggleId || "130");
  const {
    data: requisitionDataById,
    isLoading: isLoadingRequisitionById,
    refetch: refetchData,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (approveId) {
      return;
    }
    if (query.get("activeTab") === "requisition" && query.get("subActiveTab") === "purchaseRequisition") {
      navigate(
        `/dedicated/magp/manual?activeTab=requisition&subActiveTab=purchaseRequisition&thirdChildActiveTab=${
          query.get("thirdChildActiveTab") ?? "purchaseRequisitionOverview"
        }`,
        {
          replace: true,
        }
      );
      if (query.get("thirdChildActiveTab") === "purchaseRequisitionOverview") {
        setListId("26");
        setToggleId("130");
      } else if (query.get("thirdChildActiveTab") === "purchaseRequisitionPolicies") {
        setListId("26");
        setToggleId("131");
      } else if (query.get("thirdChildActiveTab") === "purchaseRequisitionProcessFlowChart") {
        setListId("26");
        setToggleId("132");
      } else {
        setListId("26");
        setToggleId("130");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "requisition" && query.get("subActiveTab") === "processingofPurchaseRequisition") {
      navigate(
        `/dedicated/magp/manual?activeTab=requisition&subActiveTab=processingofPurchaseRequisition&thirdChildActiveTab=${
          query.get("thirdChildActiveTab") ?? "processingofPurchaseRequisitionOverview"
        }`,
        {
          replace: true,
        }
      );
      if (query.get("thirdChildActiveTab") === "processingofPurchaseRequisitionOverview") {
        setListId("27");
        setToggleId("147");
      } else if (query.get("thirdChildActiveTab") === "processingofPurchaseRequisitionPolicies") {
        setListId("27");
        setToggleId("148");
      } else if (query.get("thirdChildActiveTab") === "processingofPurchaseRequisitionProcessFlowChart") {
        setListId("27");
        setToggleId("149");
      } else {
        setListId("27");
        setToggleId("147");
      }
      // refetchData();
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);
  useEffect(() => {
    refetchRequisition();
  }, []);
  useEffect(() => {
    if (listId && toggleId) {
      refetchRequisition();
    }
  }, [listId, toggleId]);

  useEffect(() => {
    if (query?.get("id")) {
      refetchData();
    }
  }, [query?.get("id")]);

  const requisitionFormConfig: FormConfig = {
    initialValues: {
      field_requisition_desc_en: requisitionDataById?.payload
        ? decodeHTML(requisitionDataById?.payload?.field_requisition_desc_en?.value)
        : decodeHTML(requisitionData?.[0]?.field_requisition_desc_en),
      field_requisition_desc_ms: requisitionDataById?.payload
        ? decodeHTML(requisitionDataById?.payload?.field_requisition_desc_ms?.value)
        : decodeHTML(requisitionData?.[0]?.field_requisition_desc_ms),
      field_requisition_desc_zh: requisitionDataById?.payload
        ? decodeHTML(requisitionDataById?.payload?.field_requisition_desc_zh?.value)
        : decodeHTML(requisitionData?.[0]?.field_requisition_desc_zh),
      field_requisition_video_url: requisitionDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: requisitionDataById?.payload?.field_requisition_video_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: requisitionData?.[0]?.field_requisition_video_url,
            },
          ]),
      field_requisit_details_web_image: requisitionDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_requisit_details_web_image.png",
              status: "done",
              url: requisitionDataById?.payload?.field_requisit_details_web_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_requisit_details_web_image.png",
              status: "done",
              url: requisitionData?.[0]?.field_requisit_details_web_image,
            },
          ]),
      field_requisition_web_flowchart: requisitionDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_requisit_details_web_image.png",
              status: "done",
              url: requisitionDataById?.payload?.field_requisition_web_flowchart,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_requisit_details_web_image.png",
              status: "done",
              url: requisitionData?.[0]?.field_requisition_web_flowchart,
            },
          ]),
    },
    fields: fields.requisition,
  };

  useEffect(() => {
    const fetchTabsData = async () => {
      try {
        const response = await magpCMSApi.get(`/api/requisition-list/all-fields`);
        const tabData = response.data.map((tab: any) => {
          const listId = tab?.id;
          const label = tab?.field_requisition_processname_en.replace(/^\d+\.\d+\s*/, "");
          let key = label.replace(/\s+/g, "").replace(/\s[a-z]/g, (match: any) => match.trim().toUpperCase());
          key = key.charAt(0).toLowerCase() + key.slice(1);
          return { listId, label, key };
        });

        // tabData.push({
        //   listId: "",
        //   label: "Process Flow Chart",
        //   key: "requisitionProcessFlowChart",
        // });

        setTabsData(tabData);
      } catch (error) {}
    };

    fetchTabsData();

    const subActiveTab = query.get("subActiveTab") || "purchaseRequisition";
    const listId = subActiveTab === "purchaseRequisition" ? "26" : "27";

    fetchSubTabsData(subActiveTab, listId);
  }, []);

  useEffect(() => {
    if (requisitionDataById !== undefined && !isLoadingRequisition) {
      const urlParams = new URLSearchParams(window.location.search);
      const subActiveTab = urlParams.get("subActiveTab") || "purchaseRequisition";
      const selectedTab = tabsData.find((tab) => tab.key === subActiveTab);

      if (selectedTab !== undefined) {
        fetchSubTabsData(subActiveTab, selectedTab.listId);
      }
    }
  }, [requisitionDataById, tabsData, isLoadingRequisition]);

  const fetchSubTabsData = async (activeKey: string, listId: string) => {
    if (!listId) {
      return;
    }
    try {
      const response = await magpCMSApi.get(`/api/requisition-topbar-toggle/all-fields?listId=${listId}`);
      const subTabData = response.data.map((subTab: any) => {
        const formattedName = subTab.name
          .replace(/\s+/g, "")
          .replace(/(\s[a-z])/g, (match: string) => match.trim().toUpperCase())
          .replace(/[^a-zA-Z0-9]/g, "");
        return {
          toggleId: subTab.id,
          listId: subTab.field_requisition_list_reference,
          label: subTab.name,
          key: `${activeKey}${formattedName}`,
        };
      });

      setSubTabsData(subTabData);
    } catch (error) {}
  };

  const handleTabChange = (activeKey: string) => {
    const selectedTab = tabsData.find((tab) => tab.key === activeKey);
    if (selectedTab) {
      fetchSubTabsData(activeKey, selectedTab.listId);
      navigate(`${window.location.pathname}?activeTab=requisition&subActiveTab=${activeKey}`);
    }
  };

  const handleSubTabChange = (listId: string, activeKey: string) => {
    setListId(listId);
    const subTab = subTabsData.find((subTab) => subTab.key === activeKey);
    if (subTab) {
      setToggleId(subTab.toggleId);
    }
    navigate(
      `${window.location.pathname}?activeTab=requisition&subActiveTab=${query?.get(
        "subActiveTab"
      )}&thirdChildActiveTab=${activeKey}`
    );
  };
  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_requisition_web_flowchart",
      "field_requisition_video_url",
      "field_requisit_details_web_image",
    ];
    let descKeys: any = ["field_requisition_desc_en", "field_requisition_desc_ms", "field_requisition_desc_zh"];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "MAGP");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        }
      } catch (error) {}
    }
    const payload = {
      action: action,
      method: method,
      module: "Manual",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get("thirdChildActiveTab")}`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        // id: requisitionDataById?.payload?.id || requisitionData?.[0]?.id || "",
        field_requisition_list_parent_id: requisitionData?.[0]?.field_requisition_list_parent_id || listId,
        field_requisition_toggle_referen: requisitionData?.[0]?.field_requisition_toggle_referen || toggleId,
        ...data,
        published: true,
        // field_requisition_det_created_at: "2024-07-16T07:44:25",
        // field_requisition_det_updated_at: "2024-07-16T07:44:30",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const superSubChildItems = tabsData.map((tab: any) => {
    return {
      label: tab.label,
      key: tab.key,
      children: (
        <Tabs
          activeKey={query?.get("thirdChildActiveTab") || ""}
          items={subTabsData.map((subTab: any) => {
            const processFlowChartTab: any[] = [
              "processingofPurchaseRequisitionProcessFlowChart",
              "purchaseRequisitionProcessFlowChart",
              "requisitionProcessFlowChart",
            ];
            const isProcessFlowChartTab = processFlowChartTab.includes(subTab.key);

            return {
              label: subTab.label,
              key: subTab.key,
              children: isProcessFlowChartTab ? (
                <>
                  <DynamicForm
                    isLoading={isLoadingRequisition || isLoadingRequisitionById}
                    config={requisitionFormConfig}
                    onSubmit={(data, buttonValue, reviewNotes) =>
                      onSubmit(
                        data,
                        `${magpHost}/api/requisition-details/${requisitionData?.[0]?.id}`,
                        "UPDATE",
                        "PATCH",
                        buttonValue == "save" ? "DRAFT" : "PENDING",
                        reviewNotes
                      )
                    }
                  />
                  <RequisitionProcessFlowChart
                    listId={listId}
                    toggleId={toggleId}
                  />
                </>
              ) : (
                <DynamicForm
                  isLoading={isLoadingRequisition || isLoadingRequisitionById}
                  config={requisitionFormConfig}
                  onSubmit={(data, buttonValue, reviewNotes) =>
                    onSubmit(
                      data,
                      `${magpHost}/api/requisition-details/${requisitionData?.[0]?.id}`,
                      "UPDATE",
                      "PATCH",
                      buttonValue == "save" ? "DRAFT" : "PENDING",
                      reviewNotes
                    )
                  }
                />
              ),
            };
          })}
          onChange={(activeKey: any) => handleSubTabChange(tab.listId, activeKey)}
        />
      ),
    };
  });

  if (isLoadingRequisition || isLoadingRequisitionById) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={superSubChildItems}
      onChange={handleTabChange}
    />
  );
};
